import { useReducer } from 'react';
import { templateContextTypes, UiContext, uiReducer } from './';
import { SideBarOptions } from '../../interfaces';

export interface UiState {
  isOpenSideBar: boolean;
  optionSidebarOpen: SideBarOptions | null;
}

const Ui_INITIAL_STATE: UiState = {
  isOpenSideBar: false,
  optionSidebarOpen: null
}

type UiProviderProps = {
  children: JSX.Element[] | JSX.Element
}

export const UiProvider = ({ children }: UiProviderProps) => {
  const [state, dispatch] = useReducer(uiReducer, Ui_INITIAL_STATE);

  /**
   * Permite cambiar el estado contrario de isOpenIA
   */
  const toggleSidebar = (optionSidebarOpen: SideBarOptions) => {
    dispatch({ type: templateContextTypes.ACTION_TYPE_TOGGLE_SIDEBAR, payload: {isOpenSideBar: !state.isOpenSideBar, optionSidebarOpen } })
  }

  /**
   * Permite cambiar el estado del sidebar a cerrado
   */
  const closeSidebar = () => {
    dispatch({ type: templateContextTypes.ACTION_CLOSE_SIDEBAR })
  }

  return (
    <UiContext.Provider value={{
      ...state,
      toggleSidebar,
      closeSidebar
    }}>
      { children }
    </UiContext.Provider>
  )
}